import 'core-js/es7/reflect';

export class AclCollection {

    // identifier
    id: string = '';
    
    // roles
    roles: Map<string, any> = null;
  
    // resources
    resources: Map<string, any> = null;
  
    // defaults
    defaults: Map<string, any> = null;
  
    // mapped indecies
    // resources_map: Map<string, any> = null;
    // roles_map: Map<string, any> = null;
  
  
    constructor ( id: string, resources?: Map<string, any>, roles?:Map<string, any> ) { 
      
      // create a map of all entries
      this.resources = new Map();
      this.roles = new Map();
      this.defaults = new Map();
  
      // identifier for this collection
      this.id = id;
  
      // if resources are passed in, process them
      if ( resources ) {
        this.createResources ( resources );
      }
  
      // if roles are passed in, process them
      if ( roles ) {
        this.createRoles ( roles);
      }
  
    }
  
    createRoles ( list: any ) {
      for (var i = 0, len = list.length; i < len; i++) {
        this.createRole ( list[i] );
      }
    }
    createRole ( element: any ) {
      if ( element.default_for ) {
        this.defaults.set ( element.id, element.default_for );
      }
      this.roles.set (element.id, new AclItem ( element ) );
    }
  
    createResources ( list: any ) {
      for (var i = 0, len = list.length; i < len; i++) {
        this.createResource ( list[i] );
      }
    }
    createResource ( element: any ) {
      this.resources.set (element.id, new AclItem ( element ) );
    }
  
  }
  
  
  export class AclItem {
  
    // identifier
    id: string = '';
  
    // features
    features: Map<string, any> = null;
  
    // group
    group: string = '';
  
    //can
    can: Map<string, any> = null;
    but_can: Map<string, any> = null;
  
    // cannot
    cannot: Map<string, any> = null;
    but_cannot: Map<string, any> = null;
  
    // is can first? (true or false) checks in what order the can and cannot's came in
    canRulesOrder: number = -1;
  
    // default for anything?
    default_for: string = null;
  
    constructor ( obj: AclItem ) {
  
      let n = -1;
  
      // we loop through the properties because order is significant
      for (var prop in obj) {
  
        // just to make sure the property is not something else (shouldn't be needed, but we like to be safe)
        if (Object.prototype.hasOwnProperty.call(obj, prop)) {
  
          // just copy over the properties
          switch ( prop ) {
            case 'id': this.id = obj.id; break;
            case 'default_for': this.default_for = obj.default_for; break;
            case 'features': this.features = obj.features; break;
            case 'group': this.group = obj.group; break;
            case 'can':  this.can = obj.can; n++; this.canRulesOrder = n; break;
            case 'but_can':  this.but_can = obj.but_can; n++; break;
            case 'cannot': this.cannot = obj.cannot; n++; break;
            case 'but_cannot': this.but_cannot = obj.but_cannot; n++; break;
            default: break;
          }
        } 
      }
    }
  
    // return this object for streaming (JSON object)
    getItemObj() {
  
      const ret = {
        'id': this.id
      };
  
      // poor hacking, needs refactoring into maping and callbacks
  
      if ( this.default_for ) {
        ret['default_for'] = this.default_for;
      }
      if ( this.features ) {
        ret['features'] = this.features;
      }
      if ( this.group ) {
        ret['group'] = this.group;
      }
  
      if ( this.canRulesOrder != -1 && this.canRulesOrder == 0 ) {
        if ( this.can ) {
          ret['can'] = this.can;
        }
        if ( this.cannot ) {
          ret['cannot'] = this.cannot;
        }
        if ( this.but_can ) {
          ret['but_can'] = this.but_can;
        }
        if ( this.but_cannot ) {
          ret['but_cannot'] = this.but_cannot;
        }
      } else {
        if ( this.cannot ) {
          ret['cannot'] = this.cannot;
        }
        if ( this.can ) {
          ret['can'] = this.can;
        }
        if ( this.but_cannot ) {
          ret['but_cannot'] = this.but_cannot;
        }
        if ( this.but_can ) {
          ret['but_can'] = this.but_can;
        }
      }
  
      // console.log ( '!!!', this.id, this.canRulesOrder, ret );
  
      return ret;
  
    }
  
  }
  
  